enum FinancingTypes {
  full_spectrum = 'full_spectrum',
  lto_only = 'lto_only',
  installment_loan = 'installment_loan',
}

export { FinancingTypes };
